// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1M2Nc","alertIcon":"ConfirmModal_alertIcon__1nsx_"};